/* eslint-disable */
import React from 'react'
import styled from 'styled-components'

import { FormatText } from '../../i18n/util'

const Wrapper = styled.div`
  display: flex;
  font-size: 13px;
  justify-content: space-between;
`

const NoDataWrap = styled.div`
  min-height: 300px;
  width: 100%;
`

const NoContent = styled.div`
  height: 200px;
  line-height: 200px;
  display: flex;
  justify-content: center;
  font-size: 13px;
  color: #212833;
  background: #fff;
  box-shadow: 0px 1px 20px 0px rgba(90, 102, 124, 0.08);
  border-radius: 3px;
`

const NoData = ({ text }) => (
  <Wrapper>
    <NoDataWrap>
      <NoContent>
        <FormatText value="noContent.descPrefix" />
        {text}
      </NoContent>
    </NoDataWrap>
  </Wrapper>
)

export default NoData
